import {z} from 'zod';

import i18n from '@dms/i18n';

export const importFormFileTypes = [
  '',
  'carisSaleVehicleCosts',
  'as3SaleVehicleCosts',
  'hondaPartsPriceList',
  'hondaRecall',
  'nissanPriceList',
] as const;

export const importFormSchema = z.object({
  fileId: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
  fileName: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
  fileType: z
    .enum(importFormFileTypes)
    .refine((fileType) => fileType !== '', {message: i18n.t('errors.field_is_required')}),
});

/** Form state includes the empty Select sentinel; Zod rejects it at submit time. */
export type ImportFormValue = z.input<typeof importFormSchema>;
